import React, { useState, useEffect } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { withCookies } from "react-cookie";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { addComment } from "../../redux/actions/tasks";
import configVars from "../../config";
import SingleComment from "./SingleComment";
// Images
import noCommentImg from "../../images/noComment.png";
import { convertToRaw } from "draft-js";

const Comments = ({ taskComments, task_id, tasklist_id, color, taskType }) => {
  const [sentCommentButton, setSentCommentButton] = useState(false);

  const dispatch = useDispatch();
  const [translation] = useTranslation("translations");
  const [comment, setComment] = useState(null);
  const [commentContent, setCommentContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allComments, setAllComments] = useState(
    taskComments ? taskComments : []
  );
  const [isBlocking, setIsBlocking] = useState(false);

  useEffect(() => {
    if (taskComments) {
      setAllComments(taskComments);
    }
  }, [taskComments]);

  // const showWriteCommentButton = () => {
  //   if (!sentCommentButton) {
  //     setSentCommentButton(true);
  //   }
  // };
  const hideWriteCommentButton = () => {
    let draft = draftToHtml(commentContent);

    if (
      sentCommentButton &&
      !isBlocking &&
      draft.replace("<p></p>", "").trim().length > 0
    ) {
      setSentCommentButton(false);
      setIsBlocking(false);
    }
  };

  const handleAddReply = (reply) => {
    setAllComments((comments) => {
      return comments.map((c) => {
        if (c.comment_id === reply.comment_parent) {
          return {
            ...c,
            children: [reply, ...c.children],
          };
        }
        return c;
      });
    });
  };

  const handleAddComment = async () => {
    try {
      setLoading(true);
      let commentObj = {
        task_id: task_id,
        // tasklist_id: tasklist_id,
        comment: draftToHtml(commentContent),
      };

      let _comment = await dispatch(
        addComment({
          comment: commentObj,
          taskId: task_id,
          listId: tasklist_id,
          taskType: taskType,
        })
      );

      if (_comment.status !== "error") {
        setAllComments([_comment.data, ...allComments]);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
    setIsBlocking(false);
    setComment(null);
    setCommentContent(null);
  };

  const handleUpdateComment = (comment) => {
    if (comment.comment_parent !== "0") {
      setAllComments((allComments) => {
        return allComments.map((c) => {
          if (c.comment_id === comment.comment_parent) {
            return {
              ...c,
              children: c.children.map((item) => {
                if (item.comment_id === comment.comment_id) {
                  return {
                    ...item,
                    comment_content: comment.comment_content,
                  };
                }
                return item;
              }),
            };
          }
          return c;
        });
      });
    } else {
      let _comments = [...allComments];
      let index = _comments.findIndex(
        (item) => item.comment_id === comment.comment_id
      );
      if (index > -1) {
        _comments[index] = { ...comment };
      }
      setAllComments([..._comments]);
    }
  };
  const handleDeleteComment = (comment) => {
    if (comment.comment_parent !== "0") {
      setAllComments((allComments) => {
        return allComments.map((c) => {
          if (c.comment_id === comment.comment_parent) {
            return {
              ...c,
              children: c.children.filter(
                (c2) => c2.comment_id !== comment.comment_id
              ),
            };
          }
          return c;
        });
      });
    } else {
      let _comments = [...allComments];
      setAllComments(
        _comments.filter((item) => item.comment_id !== comment.comment_id)
      );
    }
  };
  return (
    <div className="px-3 py-2">
      <Form.Group className="mb-3">
        <Form.Label>
          <b>{translation("buttons.send_comment")}</b>
        </Form.Label>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label className="d-flex justify-content-between justify-content-center align-content-center"></Form.Label>
        <Editor
          editorStyle={{ minHeight: "68px" }}
          toolbarOnFocus
          // onFocus={showWriteCommentButton}
          onBlur={hideWriteCommentButton}
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={comment}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          onEditorStateChange={(e) => {
            setComment(e);
          }}
          onChange={(e) => {
            setCommentContent(e);

            let draft = draftToHtml(e);
            const isEmpty = convertToRaw(
              comment.getCurrentContent()
            ).blocks.every((b) => b.text.trim() === "");
            if (!isEmpty) {
              setSentCommentButton(true);
            } else {
              setSentCommentButton(false);
            }

            if (
              !isBlocking &&
              draft.replace("<p>&nbsp;</p>", "").trim().length > 0
            ) {
              setIsBlocking(true);
            }
          }}
          placeholder={translation("task_forms.comments.placeholder")}
        />
        <div className="d-flex justify-content-end">
          {sentCommentButton && isBlocking ? (
            <Button
              variant={`${color} text-white rounded`}
              className="mx-2"
              disabled={loading}
              size="sm"
              onClick={handleAddComment}
            >
              {loading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ color: "#fff" }}
                />
              ) : (
                translation("buttons.add_comment")
              )}
            </Button>
          ) : (
            <></>
          )}
        </div>
      </Form.Group>
      {allComments?.length < 0 && (
        <figure className="figure w-100 d-flex justify-content-center">
          <div>
            <img
              style={{ width: "200px" }}
              src={noCommentImg}
              className="figure-img img-fluid rounded "
              alt="No-Comments"
            />
          </div>
        </figure>
      )}
      <Form.Label className="d-flex text-capitalize">
        <b>
          {allComments?.length > 0 &&
            translation("task_forms.comments.commentsSubHeading")}
        </b>
      </Form.Label>

      <div>
        {allComments?.map((comment, index) => {
          return (
            <div key={comment?.comment_id}>
              <SingleComment
                comment={comment}
                task_id={task_id}
                tasklist_id={tasklist_id}
                color={color}
                showActions={true}
                showEdit={true}
                showDelete={true}
                handleUpdateComment={handleUpdateComment}
                handleDeleteComment={handleDeleteComment}
                onAddReply={handleAddReply}
                taskType={taskType}
              />
              <div className="ms-4 mt-3 comment-replies">
                {comment?.children?.map((rep, childIndex) => {
                  return (
                    <SingleComment
                      key={rep?.comment_id}
                      comment={rep}
                      task_id={task_id}
                      tasklist_id={tasklist_id}
                      color={color}
                      showActions={false}
                      showEdit={true}
                      showDelete={true}
                      handleUpdateComment={handleUpdateComment}
                      handleDeleteComment={handleDeleteComment}
                      onAddReply={handleAddReply}
                      taskType={taskType}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default withCookies(Comments);
